import { Box, Divider, Typography } from "@mui/material"
import type { FC } from "react"
import { useForm } from "react-hook-form"

import { COMPUTED_STATUS_LIST, PRIORITY_STATUS_LABELS } from "../constants"

import { StatusFilter } from "@/components/common/Filters"
import { SearchFilterDrawer } from "@/components/common/SearchFilterDrawer/SearchFilterDrawer"
import { PRODUCT_STATUS_LABEL_MAP } from "@/constants/product"
import type { ComputedProductStatus } from "@/graphql/codegen/graphql"
import { PriorityStatus } from "@/graphql/codegen/graphql"

interface FilterFormValues {
  computedProductStatuses: ComputedProductStatus[]
  priorityStatus: PriorityStatus[]
}

interface CustomerProductFilterDrawerProps {
  open: boolean
  selectedComputedStatuses: ComputedProductStatus[]
  selectedPriorityStatuses: PriorityStatus[]
  isClearButtonEnabled: boolean
  onClose: () => void
  onComputedStatusChange: (statuses: ComputedProductStatus[]) => void
  onPriorityStatusChange: (statuses: PriorityStatus[]) => void
  onClear: () => void
}

export const CustomerProductFilterDrawer: FC<CustomerProductFilterDrawerProps> = ({
  open,
  selectedComputedStatuses,
  selectedPriorityStatuses,
  isClearButtonEnabled,
  onClose,
  onComputedStatusChange,
  onPriorityStatusChange,
  onClear,
}) => {
  const { control } = useForm<FilterFormValues>({
    values: {
      computedProductStatuses: selectedComputedStatuses,
      priorityStatus: selectedPriorityStatuses,
    },
  })

  return (
    <SearchFilterDrawer
      open={open}
      toggleDrawer={onClose}
      clear={onClear}
      isClearButtonEnabled={isClearButtonEnabled}
      testId='customer-product-filter-drawer'
    >
      <Box className='flex flex-col'>
        <Typography variant='subtitle1' className='px-4 py-1.5 font-bold text-gray-700'>
          Product Status
        </Typography>
        <Divider />
        <StatusFilter
          name='computedProductStatuses'
          data={COMPUTED_STATUS_LIST}
          control={control}
          onFilterChange={(_, value) => onComputedStatusChange(Array.isArray(value) ? value : [value])}
          labelMap={PRODUCT_STATUS_LABEL_MAP}
        />
      </Box>

      <Box className='flex flex-col'>
        <Typography variant='subtitle1' className='px-4 py-1.5 font-bold text-gray-700'>
          Priority
        </Typography>
        <Divider />
        <StatusFilter
          name='priorityStatus'
          data={Object.values(PriorityStatus)}
          control={control}
          onFilterChange={(_, value) => onPriorityStatusChange(Array.isArray(value) ? value : [value])}
          labelMap={PRIORITY_STATUS_LABELS}
          multiple={true}
        />
      </Box>
    </SearchFilterDrawer>
  )
}
